// Import regular JavaScript

// Import common modules
const Loader  = require('Scripts/common/loader');

// Toolkit
const Customiser      = require('Scripts/admin/toolkit/customiser');
const Toolkit         = require('Scripts/admin/toolkit/toolkit');

// Define groups of modules - the group name is set in your template ($jsModuleGroup). 
// This is just a nicer way to load JS on specific pages without looking at the path/params
// To initiate a group, use the #module macro. E.g. #module("my-group") would add 'my-group' from the groups below.
const moduleGroups = {
	// Available on every page
	'global': [Toolkit],

	// Available on specific pages
	'customiser':       [Customiser],
};

Loader.load(moduleGroups);